// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5e-0";
export var eligibilityCardNotEligible = "_5e-1";